import React, { useState, useEffect, useRef } from 'react'
import { FormControl, Table, Button, OverlayTrigger } from 'react-bootstrap';
import { FetchRegisterSalesReport, FetchSalesReportFaex, FetchBillClearance } from '../../fetcher';
import AlertMessage from '../presentational-components/AlertMessage';
import { useSingleDateFilter, useDateFilter, useSearchFilter, useSelectFilter, useFilterReport, DateSelect } from '../presentational-components/filterutils';
import LoadingSpinner from '../presentational-components/LoadingSpinner';
import { useSortSalesReport } from '../presentational-components/tablehooks';
import moment from 'moment'
import 'moment/locale/de'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { ExportCSV } from '../presentational-components/ExportCSV';
import DescriptionTooltip from '../presentational-components/DescriptionTooltip';
import { SimpleDateSelect } from '../presentational-components/FilterComponents'
import EnumValueTranslations from '../presentational-components/EnumValueTranslations'

moment.locale('de')

const SalesReport = () => {

    const [isFaexStorage, setIsFaexStorage] = useState(false)
    const [filterable, setFilterable] = useState(false)
    const [filteredReports, setFilteredReports] = useState([])
    const [sortedReports, setSortedReports] = useState([])
    const [salesReport, setSalesReport] = useState([])
    const [selectionForBillClearance, setSelectionForBillClearance] = useState([])
    const [lastSelected, setLastSelected] = useState("")
    const [options, setOptions] = useState([])

    const { sortSalesReport } = useSortSalesReport(salesReport, setSortedReports)
    const { filterReportBySearchInput, filterReportByDateInput, filterReportBySelectInput } = useFilterReport()
    const { dateSelect, handleDatePickerCallback, handleClearFilter } = useDateFilter()
    const { singleDateSelect, handleSingleDatePickerCallback, handleClearFilter1 } = useSingleDateFilter()

    const [statusSelect, handleStatusSelectChange] = useSelectFilter()
    const { searchInput, handleSearchInput } = useSearchFilter()

    const [boutiqueSelection, setBoutiqueSelection] = useState("")
    const [designerSelection, setDesignerSelection] = useState("")
    const [dateSelection, setDateSelection] = useState({ "startDate": moment(moment().subtract(13, 'days').toDate()).format("DD.MM.YYYY"), "endDate": moment(moment().toDate()).format("DD.MM.YYYY") })

    const [taskName, setTaskName] = useState("SalesReport unbekannter Task")
    const controller = new AbortController()
    const signal = controller.signal

    const [showAlertMessage, setShowAlert] = useState(false)

    const [billClearance, setBillClearance] = useState(false)
    const [billingCommandState, setBillingCommandState] = useState("Verkaufsabrechnung starten")
    const [billClearanceDate, setBillClearanceDate] = useState(singleDateSelect !== undefined && singleDateSelect !== "" ? singleDateSelect : moment(Date.now()).format("DD.MM.YYYY"))

    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }

    useEffect(() => {
        if (JSON.parse(sessionStorage.getItem("loginInformation")).StorageType === "FAEX") {
            setIsFaexStorage(true)
        }
    }, [])

    useEffect(() => {
        setTaskName("Auswertungsoptionen werden geladen")
        FetchRegisterSalesReport(setOptions, openAlert, signal, "SalesReport")

        return () => {
            controller.abort()
        }
    }, [])

    useEffect(() => {
        console.log("SalesReport useEffect")
        console.log(salesReport)
        setFilteredReports([...salesReport])
        setSortedReports([...salesReport])
    }, [salesReport])

    useEffect(() => {
        let filteredReport = filterReportBySearchInput([...sortedReports], searchInput)
        //filteredReport = filterReportByDateInput(filteredReport, dateSelect)
        //filteredReport = filterReportBySelectInput(filteredReport, statusSelect)
        setFilteredReports(filteredReport)
    }, [searchInput, dateSelect, statusSelect, sortedReports])

    useEffect(() => {
        setBillClearanceDate(moment(singleDateSelect.start).format("DD.MM.YYYY"))
    }, [singleDateSelect])

    useEffect(() => {
        setBillingCommandState(billClearance ? "Verkaufsabrechnung beenden" : "Verkaufsabrechnung starten")
        setSelectionForBillClearance([])
    }, [billClearance])

    const onSelectionChanged = (e) => {
        if (e.target.checked) {
            let selectionCopy = [...selectionForBillClearance]
            selectionCopy.push(e.target.value)
            setSelectionForBillClearance(selectionCopy)
        }
        else {
            setSelectionForBillClearance(selectionForBillClearance.filter(x => x != e.target.value))
        }

        setLastSelected(e.target.value)
        console.log("onSelectionChanged onSelectionChanged", e.target.checked, selectionForBillClearance)
    }

    const loadReport = (startDate, endDate, designerSysId, boutiqueSysId) => {
        let requestParam = {
            "Name": options[0].Name,
            "ReportId": options[0].ReportId.toString(),
            "StartDate": startDate,
            "EndDate": endDate,
            "BoutiqueSysId": boutiqueSysId,
            "DesignerSysId": designerSysId
        }
        setSelectionForBillClearance([])
        FetchSalesReportFaex(setSalesReport, requestParam, openAlert, signal, "SalesReport")
    }

    const loadDateRangePicker = () => {
        const showCustomRangeLabel = true

        const getDefaultValue = () => {
            if (dateSelect !== "" && dateSelect.start._d !== "") {
                const startDate = moment(dateSelect.start._d).format("DD.MM.YYYY")
                const endDate = moment(dateSelect.end._d).format("DD.MM.YYYY")
                return (startDate +
                    ' - ' + endDate)
            } else {
                const startDate = moment(moment().subtract(13, 'days').toDate()).format("DD.MM.YYYY")
                const endDate = moment(moment().toDate()).format("DD.MM.YYYY")
                return (startDate +
                    ' - ' + endDate)
            }
        }
        const handleApply = (event, picker) => {
            picker.element.val(
                picker.startDate.format('DD.MM.YYYY') +
                ' - ' +
                picker.endDate.format('DD.MM.YYYY')
            )
            handleDatePickerCallback(picker.startDate, picker.endDate)
            setDateSelection({ "startDate": picker.startDate.format('DD.MM.YYYY'), "endDate": picker.endDate.format('DD.MM.YYYY') })
        }
        const handleCancel = (event, picker) => {
            picker.element.val('')
            handleClearFilter()
        }
        const handleCallback = (start, end) => {
            //24.01.22 RB: onCallback from DateRangePicker seems to be broken, 
            //handles setting the datepicker variables via handleApply now(called when pressing OK button)

            //handleDatePickerCallback(start, end)
        }

        let predefRange = {}
        predefRange["Heute"] = [moment(), moment()]
        predefRange["7 Tage"] = [
            moment().subtract(6, 'days').toDate(),
            moment().toDate(),
        ]
        predefRange["14 Tage"] = [
            moment().subtract(13, 'days').toDate(),
            moment().toDate(),
        ]
        predefRange["30 Tage"] = [
            moment().subtract(29, 'days').toDate(),
            moment().toDate(),
        ]
        predefRange["Dieser Monat"] = [
            moment().startOf('month').toDate(),
            moment().endOf('month').toDate(),
        ]
        predefRange["Letzter Monat"] = [
            moment().subtract(1, 'month').startOf('month').toDate(),
            moment().subtract(1, 'month').endOf('month').toDate(),
        ]
        predefRange["Dieses Jahr"] = [
            moment().startOf('year').toDate(),
            moment().endOf('year').toDate(),
        ]
        predefRange["Alle"] = [
            moment(moment.utc("0001-01-01")).format('DD.MM.YYYY'),
            moment().toDate(),
        ]

        return (
            <DateRangePicker initialSettings={{
                showCustomRangeLabel,
                locale: {
                    cancelLabel: 'Zurücksetzen',
                    applyLabel: 'Ok',
                    customRangeLabel: 'Manuell'
                },
                autoUpdateInput: false,
                ranges: predefRange,
            }} onApply={handleApply} onCancel={handleCancel}
                onCallback={(start, end) => handleCallback(start, end)} isClearable={true}>
                <FormControl className="dateFilterForm" size="sm" defaultValue={getDefaultValue()} />
            </DateRangePicker>
        )
    }

    const handleSetDesignerSelection = (designerSelect) => {
        let selectedDesigner = options[0].ReportParameters.find(y => y.Order === (isFaexStorage ? 4 : 3)).Designers.find(x => x.Name.trim() === designerSelect.trim())
        if (selectedDesigner !== undefined) setDesignerSelection(selectedDesigner.DesignerSysId)
    }

    const loadDesignerSelection = () => {
        if (options !== null && options[0] !== undefined) {
            let designerNames = options[0].ReportParameters.find(y => y.Order === (isFaexStorage ? 4 : 3)).Designers.map(x => x.Name).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
            let all = designerNames.splice(designerNames.findIndex(a => a.includes('Alle')), 1)
            designerNames.splice(0, 0, all[0])
            return (
                <FormControl className="filterForm reportSelect" defaultValue="" as="select" size="sm" onChange={(e) => handleSetDesignerSelection(e.target.value)}>
                    {designerNames.map(x => <option>{x}</option>)}
                </FormControl>
            )
        }
    }

    const handleSetBoutiqueSelection = (boutiqueSelect) => {
        let selectedBoutique = options[0].ReportParameters.find(y => y.Order == 1).SalesPoints.find(x => x.Name === boutiqueSelect)
        setBoutiqueSelection(selectedBoutique.SalesPointSysId)
    }

    const loadBoutiqueSelection = () => {
        if (options !== null && options[0] !== undefined) {
            let boutiqueNames = options[0].ReportParameters.find(y => y.Order == 1).SalesPoints.map(x => x.Name).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
            let all = boutiqueNames.splice(boutiqueNames.findIndex(a => a.includes('Alle')), 1)
            boutiqueNames.splice(0, 0, all[0]);
            return (
                <FormControl className="filterForm reportSelect" defaultValue="" as="select" size="sm" onChange={(e) => handleSetBoutiqueSelection(e.target.value)}>
                    {boutiqueNames.map(x => <option>{x}</option>)}
                </FormControl>
            )
        }
    }

    const handleReportLoad = () => {
        setTaskName(prev => prev = "Auswertung wird geladen")
        loadReport(dateSelection.startDate, dateSelection.endDate, designerSelection, boutiqueSelection)
    }

    const setFilterbar = () => {
        setFilterable(!filterable)
    }

    const getCsvData = () => {
        let csvData
        isFaexStorage ?
            csvData = salesReport.map(x =>
            ({
                "Verkaufsstelle": x.SalesPoint,
                "Verkaufsdatum": x.Date,
                "Designer": x.Designer,
                "Artikelnr. FAEX": x.FAEXArticleNumber,
                "Artikelnr. Designer": x.ArticleNumberDesigner,
                "Artikelname": x.ArticleName,
                "Farbe": x.Colour,
                "Größe": x.Size,
                "Anzahl": x.Amount,
                "Einzelpreis": x.DefaultSalePrice,
                "VK Preis": x.PriceAtPointOfSelling,
                "davon bar": x.PaidInCash,
                "davon EC": x.PaidWithDebitCreditCard,
                "davon Paypal": x.PaidWithPaypal,
                "davon Überweisung": x.PaidViaBankTransfer,
                "Bemerkung": x.Remark,
                "Sum UP Zahlung gebucht": "",
                "Rabatt gewährt": x.Rabate,
                "FAEX Ertrag 30/35/40/45/10/20/": x.FAEXEarnings,
                "PaymentForDesignerBrutto": x.PaymentForDesignerBrutto,
                "PaymentForDesignerNetto": x.PaymentForDesignerNetto,
                "RG vom Designer erhalten am": ""
            })) :
            csvData = salesReport.map(x =>
            ({
                "Verkaufsdatum": x.Date,
                "Designer": x.Designer,
                "Artikelnr. FAEX": x.FAEXArticleNumber,
                "Artikelnr. Designer": x.ArticleNumberDesigner,
                "Artikelname": x.ArticleName,
                "Farbe": x.Colour,
                "Größe": x.Size,
                "Anzahl": x.Amount,
                "Einzelpreis": x.DefaultSalePrice,
                "VK Preis": x.PriceAtPointOfSelling,
                "davon bar": x.PaidInCash,
                "davon EC": x.PaidWithDebitCreditCard,
                "davon Paypal": x.PaidWithPaypal,
                "davon Überweisung": x.PaidViaBankTransfer,
                "Bemerkung": x.Remark,
                "Rabatt gewährt": x.Rabate,
                "minus 40 % inkl. Rabatte": x.Earnings,
                "PaymentForDesignerBrutto": x.PaymentForDesignerBrutto,
                "PaymentForDesignerNetto": x.PaymentForDesignerNetto,
            }))

        return (csvData)
    }

    const getTotalAmount = (filteredReports) => {
        let total = 0
        let numbers = filteredReports.map(x => parseInt(x.Amount))
        total = numbers.reduce((a, b) => a + b, 0)

        return total
    }

    const getTotalPrices = (filteredReports, field) => {
        let total = 0
        let numbers = filteredReports.map(x => parseFloat(x[field]))
        total = numbers.reduce((a, b) => a + b, 0)

        return total
    }

    const reload = () => {
        handleReportLoad()
    }

    const updateSalesListForClearance = (e) => {
        e.preventDefault()

        console.log("moment(billClearanceDate).moment(billClearanceDate).moment(billClearanceDate).moment(billClearanceDate).", moment(billClearanceDate), moment(billClearanceDate))
        let checked = selectionForBillClearance.map(x => { return { SoldItemSysId: x } })

        let billClearanceData = { Date: moment(billClearanceDate)._i, BillClearances: checked }

        console.log("billClearanceData", billClearanceData, moment(billClearanceDate))
        setTaskName("Die Verkaufsabrechnungen werden durchgeführt")
        FetchBillClearance(billClearanceData, openAlert, reload, signal, "SalesReport")

    }



    const SalesReportListFaex = () => {
        return (
            <>
                <SalesReportFaex />
                <div className="tablet-transactions">
                    <Table className="table-sm table-striped-immediate ">
                        <thead className="sticky-table-header">
                            {billClearance && <th className="mainColumn"> Verkäufe auswählen </th>}
                            <th className="mainColumn">Art vom Verkauf
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'SalesType')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Verkaufsstelle
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'SalesPoint')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Verkaufsdatum
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Date')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Designer
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Designer')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Artikelnr. FAEX
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'FAEXArticleNumber')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Artikelnr. Designer
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'ArticleNumberDesigner')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Artikelname
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'ArticleName')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Farbe
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Colour')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Größe
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Size')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Anzahl
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Amount')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Einzelpreis
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'DefaultSalePrice')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Rabatt gewährt
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Rabate')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">VK - Preis
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'PriceAtPointOfSelling')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">davon bar
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'PaidInCash')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">davon EC
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'PaidWithDebitCreditCard')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Paypal
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'PaidWithPaypal')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Überweisung
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'PaidViaBankTransfer')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn-large2">Abrechnungsdatum
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'ClearanceDate')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Bemerkung
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Remark')}>&#8593; &#8595;</a>
                            </th>
                            {/*<th className="mainColumn-large">FAEX Ertrag 30/35/40/45/10/20/*/}
                            {/*    <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'FAEXEarnings')}>&#8593; &#8595;</a>*/}
                            {/*</th>*/}
                            {/*<th className="mainColumn-large">Zahlung brutto an Designer*/}
                            {/*    <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'PaymentForDesignerBrutto')}>&#8593; &#8595;</a>*/}
                            {/*</th>*/}
                            {/*<th className="mainColumn-large">Zahlung netto an Designer*/}
                            {/*    <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'PaymentForDesignerNetto')}>&#8593; &#8595;</a>*/}
                            {/*</th>*/}
                            {/*<th className="filterIndicator" onClick={setFilterbar}>&#8711; Filter</th>*/}
                            <th></th>
                        </thead>
                        {filterable ? <thead>
                            <th></th><th></th><th>{DateSelect(handleDatePickerCallback, handleClearFilter, dateSelect)}</th>
                            <th></th><th></th><th></th>
                            <th></th><th></th><th></th>
                            <th></th><th></th><th></th>
                            <th></th><th></th><th></th>
                            <th></th><th></th><th></th>
                            <th></th><th></th><th></th>
                        </thead> : null}

                        <tbody>
                            {filteredReports.map(entry =>
                                <>
                                    <tr id={entry.SalesSysId}>
                                        {billClearance && <input className="BillClearance" value={entry.SalesSysId} type="checkbox" onChange={(e) => onSelectionChanged(e)} checked={selectionForBillClearance.includes(entry.SalesSysId)} autoFocus={lastSelected == entry.SalesSysId} />}
                                        <td>{EnumValueTranslations(entry.SalesType)}</td>
                                        <td>{entry.SalesPoint}</td>
                                        <td>{entry.Date}</td>
                                        <td>{entry.Designer}</td>
                                        <td>{entry.FAEXArticleNumber}</td>
                                        <td>{entry.ArticleNumberDesigner}</td>
                                        <td>{entry.ArticleName}</td>
                                        <td>{entry.Colour}</td>
                                        <td>{entry.Size}</td>
                                        <td className="numberColumn">{entry.Amount}</td>
                                        <td className="numberColumn">{parseFloat(entry.DefaultSalePrice).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td className="numberColumn">{parseFloat(entry.Rabate).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td className="numberColumn">{parseFloat(entry.PriceAtPointOfSelling).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td className="numberColumn">{parseFloat(entry.PaidInCash).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td className="numberColumn">{parseFloat(entry.PaidWithDebitCreditCard).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td className="numberColumn">{parseFloat(entry.PaidWithPaypal).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td className="numberColumn">{parseFloat(entry.PaidViaBankTransfer).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td>{entry.ClearanceDate}</td>
                                        <OverlayTrigger trigger={["hover", "click"]} placement="top" overlay={DescriptionTooltip(entry.Remark)}>
                                            <td className="remark-td">{entry.Remark}</td>
                                        </OverlayTrigger>
                                        {/*<td className="numberColumn">{parseFloat(entry.PriceAtPointOfSelling).toFixed(2).replace('.', ',') + "€"}</td>*/}
                                        {/*<td className="numberColumn">{parseFloat(entry.FAEXEarnings).toFixed(2).replace('.', ',') + "€"}</td>*/}
                                        {/*<td className="numberColumn">{parseFloat(entry.PaymentForDesignerBrutto).toFixed(2).replace('.', ',') + "€"}</td>*/}
                                        {/*<td className="numberColumn">{parseFloat(entry.PaymentForDesignerNetto).toFixed(2).replace('.', ',') + "€"}</td>*/}
                                        <td></td>
                                    </tr>
                                </>
                            )}
                            <tr className="stockReport-row">
                                {billClearance && <td></td>}
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Summe: </td>
                                <td className="numberColumn">{getTotalAmount(filteredReports)}</td>
                                <td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "DefaultSalePrice")).toFixed(2).replace('.', ',') + "€"}</td>
                                <td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "Rabate")).toFixed(2).replace('.', ',') + "€"}</td>
                                <td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "PriceAtPointOfSelling")).toFixed(2).replace('.', ',') + "€"}</td>
                                <td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "PaidInCash")).toFixed(2).replace('.', ',') + "€"}</td>
                                <td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "PaidWithDebitCreditCard")).toFixed(2).replace('.', ',') + "€"}</td>
                                <td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "PaidWithPaypal")).toFixed(2).replace('.', ',') + "€"}</td>
                                <td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "PaidViaBankTransfer")).toFixed(2).replace('.', ',') + "€"}</td>
                                <td></td>
                                {/*<td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "FAEXEarnings")).toFixed(2).replace('.', ',') + "€"}</td>*/}
                                {/*<td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "PaymentForDesignerBrutto")).toFixed(2).replace('.', ',') + "€"}</td>*/}
                                {/*<td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "PaymentForDesignerNetto")).toFixed(2).replace('.', ',') + "€"}</td>*/}
                            </tr>
                        </tbody>
                    </Table>
                </div>

                <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
            </>
        )
    }

    const SalesReportFaex = () => {
        return (
            <>
                <br />
                <div className="inline searchBar">
                    <Button className="form filter-button form-control sales-report-btn" variant="secondary" block size="sm" type="submit" onClick={(e) => setBillClearance(oldvalue => !oldvalue)}>{billingCommandState}</Button>
                    {billClearance &&
                        <div className="inline">
                            {SimpleDateSelect(handleSingleDatePickerCallback, handleClearFilter1, billClearanceDate)}
                            &nbsp;&nbsp;
                            <Button className="form filter-button form-control sales-report-btn" variant="secondary" block size="sm" type="submit" onClick={(e) => updateSalesListForClearance(e)}> Ausgewählten Verkäufe zum gewählten Datum abrechnen </Button>
                        </div>}
                </div>
            </>
        )
    }

    const SalesReportBoutique = () => {
        return (
            <>
                <div className="tablet-transactions">
                    <Table className="table-sm table-striped-immediate ">
                        <thead className="sticky-table-header">
                            <th className="mainColumn">Verkaufsdatum
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Date')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Designer
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Designer')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Artikelnr. FAEX
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'FAEXArticleNumber')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Artikelnr. Designer
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'ArticleNumberDesigner')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Artikelname
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'ArticleName')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Farbe
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Colour')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Größe
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Size')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Anzahl
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Amount')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Einzelpreis
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'DefaultSalePrice')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">VK Preis
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'PriceAtPointOfSelling')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">davon bar
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'PaidInCash')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">davon EC
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'PaidWithDebitCreditCard')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Paypal
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'PaidWithPaypal')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Überweisung
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'PaidViaBankTransfer')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Bemerkung
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Remark')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn">Rabatt gewährt
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Rabate')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn-large">minus 40 % inkl. Rabatte
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'Earnings')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn-large">Zahlung brutto an Designer
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'PaymentForDesignerBrutto')}>&#8593; &#8595;</a>
                            </th>
                            <th className="mainColumn-large">Zahlung netto an Designer
                                <a href="" className="sort-link" onClick={(e) => sortSalesReport(e, 'PaymentForDesignerNetto')}>&#8593; &#8595;</a>
                            </th>
                            {/*<th className="filterIndicator" onClick={setFilterbar}>&#8711; Filter</th>*/}
                            <th></th>
                        </thead>
                        {filterable ? <thead>
                            <th></th><th>{DateSelect(handleDatePickerCallback, handleClearFilter, dateSelect)}</th>
                            <th></th><th></th><th></th>
                            <th></th><th></th><th></th>
                            <th></th><th></th><th></th>
                            <th></th><th></th><th></th>
                            <th></th><th></th><th></th>
                            <th></th><th></th><th></th>
                        </thead> : null}

                        <tbody>
                            {filteredReports.map(entry =>
                                <>
                                    <tr>
                                        <td>{entry.Date}</td>
                                        <td>{entry.Designer}</td>
                                        <td>{entry.FAEXArticleNumber}</td>
                                        <td>{entry.ArticleNumberDesigner}</td>
                                        <td>{entry.ArticleName}</td>
                                        <td>{entry.Colour}</td>
                                        <td>{entry.Size}</td>
                                        <td className="numberColumn">{entry.Amount}</td>
                                        <td className="numberColumn">{parseFloat(entry.DefaultSalePrice).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td className="numberColumn">{parseFloat(entry.PriceAtPointOfSelling).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td className="numberColumn">{parseFloat(entry.PaidInCash).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td className="numberColumn">{parseFloat(entry.PaidWithDebitCreditCard).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td className="numberColumn">{parseFloat(entry.PaidWithPaypal).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td className="numberColumn">{parseFloat(entry.PaidViaBankTransfer).toFixed(2).replace('.', ',') + "€"}</td>
                                        <OverlayTrigger trigger={["hover", "click"]} placement="top" overlay={DescriptionTooltip(entry.Remark)}>
                                            <td className="remark-td">{entry.Remark}</td>
                                        </OverlayTrigger>
                                        <td className="numberColumn">{parseFloat(entry.Rabate).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td className="numberColumn">{parseFloat(entry.Earnings).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td className="numberColumn">{parseFloat(entry.PaymentForDesignerBrutto).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td className="numberColumn">{parseFloat(entry.PaymentForDesignerNetto).toFixed(2).replace('.', ',') + "€"}</td>
                                    </tr>
                                </>
                            )}

                            <tr className="stockReport-row">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Summe: </td>
                                <td className="numberColumn">{getTotalAmount(filteredReports)}</td>
                                <td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "DefaultSalePrice")).toFixed(2).replace('.', ',') + "€"}</td>
                                <td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "PriceAtPointOfSelling")).toFixed(2).replace('.', ',') + "€"}</td>
                                <td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "PaidInCash")).toFixed(2).replace('.', ',') + "€"}</td>
                                <td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "PaidWithDebitCreditCard")).toFixed(2).replace('.', ',') + "€"}</td>
                                <td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "PaidWithPaypal")).toFixed(2).replace('.', ',') + "€"}</td>
                                <td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "PaidViaBankTransfer")).toFixed(2).replace('.', ',') + "€"}</td>
                                <td></td>
                                <td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "Rabate")).toFixed(2).replace('.', ',') + "€"}</td>
                                <td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "Earnings")).toFixed(2).replace('.', ',') + "€"}</td>
                                <td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "PaymentForDesignerBrutto")).toFixed(2).replace('.', ',') + "€"}</td>
                                <td className="numberColumn">{parseFloat(getTotalPrices(filteredReports, "PaymentForDesignerNetto")).toFixed(2).replace('.', ',') + "€"}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>

                <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
            </>
        )
    }

    return (
        <>
            <div className="report-menu searchBar">
                <div className="inline">
                    {loadDateRangePicker()}
                    &nbsp;
                    {loadDesignerSelection()}
                    &nbsp;
                    {isFaexStorage && loadBoutiqueSelection()}
                    &nbsp;&nbsp;
                    <Button variant="light" size="sm" className="form filter-button form-control sales-report-btn" onClick={() => handleReportLoad()}>Auswertung laden</Button>
                </div>
            </div>
            <br />
            <LoadingSpinner task={taskName} area={"SalesReport"} />

            <div className="inline">
                <FormControl className="globalSearch searchBar" as="input" defaultValue={searchInput} placeholder="Suche..." onChange={handleSearchInput}></FormControl>
                <ExportCSV className="searchBar" csvData={getCsvData()} fileName={"Verkäufe"} />
                {/*<div className="inline-forms">*/}
                {/*    <ExportCSV className="searchBar" disabled={disableExport} csvData={getCsvData()} fileName={"Verkäufe"} />*/}
                {/*</div>*/}
            </div>

            {isFaexStorage ? <SalesReportListFaex /> : <SalesReportBoutique />}
        </>
    )
    
}

export { SalesReport }